import { Constants } from "../lib/constants";


export namespace StringHelper {

    export function whenNullOrEmpty(value: string | null | undefined, defaultValue: string): string {
        if (isNullOrEmpty(value)) {
            return defaultValue;
        }

        return value ?? defaultValue;
    }

    export function isNullOrEmpty(value: string | null | undefined): boolean {
        if (value === null) {
            return true;
        }

        if (value === undefined) {
            return true;
        }

        if (value.toString().trim() === Constants.emptyString) {
            return true;
        }

        return false;
    }

    export function isNotNullOrEmpty(value?: string | undefined): boolean {
        return !isNullOrEmpty(value);
    }

    export function enforceStartsWith(input: string, value: string): string {
        if (input === undefined || input === Constants.emptyString) {
            return Constants.emptyString;
        }

        if (input.startsWith(value)) {
            return input;
        }

        return value + input;
    }

    export function enforceEndsWith(input: string, value: string): string {
        if (input === undefined || input === Constants.emptyString) {
            return Constants.emptyString;
        }

        if (input.endsWith(value)) {
            return input;
        }

        return input + value;
    }

    export function replacePlaceholders(input: string, data: Record<string, any>): string {
        return input.replace(/\{\{(.*?)\}\}/g, (match: string, key: string) => {
            // Check if the key exists in the data object
            if (data.hasOwnProperty(key)) {
                return data[key]; // Replace with the value of the corresponding key
            }
            return match; // Return the original match if the key is not found
        });
    }

    export function replaceRouteParam(input: string, key: string, value: string | number | null | undefined): string {
        if (isNullOrEmpty(input) || isNullOrEmpty(key) || value === null || value === undefined) {
            return input;
        }

        return input.replaceAll(`{${key}}`, encodeURIComponent(value.toString()));
    }

    export function replaceRouteParams(input: string, data?: Record<string, string | number | null | undefined>): string {
        if (isNullOrEmpty(input) || data === undefined || data === null) {
            return input;
        }

        let result: string = input;
        Object.keys(data).forEach((key) => {
            result = replaceRouteParam(result, key, data[key]);
        });

        return result;
    }
}


